<template>
  <div>
    <vs-popup :title="$t('ModifyReceiver')" :active.sync="showModal">
      <form>
        <div>
          <vs-input
            class="inputx mb-3"
            v-model="receiverForModify.fullName"
            :label="$t('Name')"
            name="Name"
            v-validate="{ min: '2', required: 'true' }"
          />
          <span class="text-danger text-sm" v-show="errors.has('Name')">{{
            errors.first("Name")
          }}</span>
        </div>
        <div>
          <vs-input
            class="inputx mb-3"
            v-model="receiverForModify.emailAddress"
            :label="$t('Email')"
            name="Email"
            v-validate="{
              regex: '[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+',
              required: 'true'
            }"
          />
          <span class="text-danger text-sm" v-show="errors.has('Email')">{{
            errors.first("Email")
          }}</span>
        </div>
        <div>
          <vs-input
            class="inputx mb-3"
            v-model="receiverForModify.phoneNumber"
            :label="$t('PhoneNumber')"
            name="PhoneNumber"
            v-validate="{ regex: '^([0-9]+)$', required: 'true', digits: '11' }"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('PhoneNumber')"
            >{{ errors.first("PhoneNumber") }}</span
          >
        </div>

        <vs-button
          type="filled"
          class="float-right my-4"
          @click.prevent="submitForm"
          :disabled="disabled"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
const dict = {
  custom: {
    Name: {
      required: "لطفا نام گیرنده را وارد نمایید.",
      min: "نام گیرنده معتبر نمی باشد."
    },
    Email: {
      required: "لطفا ایمیل گیرنده را وارد نمایید.",
      regex: "ایمیل گیرنده معتبر نمی باشد"
    },
    PhoneNumber: {
      required: "لطفا شماره تلفن گیرنده را وارد نمایید.",
      regex: "شماره تلفن گیرنده معتبر نمی باشد",
      digits: "شماره تلفن گیرنده معتبر نمی باشد"
    }
  }
};
Validator.localize("fa", dict);
export default {
  name: "",
  props: {
    show: { default: false },
    receiverForModify: {}
  },
  components: {},
  data() {
    return {
      model: {},
      disabled: false
    };
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
  methods: {
    ...mapActions({
      modifyReceiver: "notification/modifyReceiver"
    }),
    submitForm() {
      this.$validator.validateAll().then(r => {
        if (r) {
          this.modifyReceiver(this.receiverForModify).then(() => {
            this.disabled = false;
            this.$emit("finish");
            this.model = {};
          });
        } else {
          this.$swal({
            position: "center-center",
            type: "warning",
            text: "خطا در ثبت مقادیر وارده شده",
            showConfirmButton: false,
            timer: 2000
          });
        }
      });
    }
  }
};
</script>
